import { CoursesMonitoringTable } from "components/monitoring/CoursesMonitoringTable";

export default function Page() {
  return <CoursesMonitoringTable />;
}
